(function ($) {
    $(() => {
        $("#general-construction-calculation-form :input[type='text']").keyup($.debounce(
            function () {
                if ($('.js-results').is(":visible")) {
                    $('#general-construction-calculation-form').submit();
                }
            }, 500));


        $("#general-construction-calculation-form :input[type='radio']").change(function () {
            if ($('.js-results').is(":visible")) {
                $('#general-construction-calculation-form').submit();
            }
        });


        $('#general-construction-calculation-form').submit(function (event) {
            event.preventDefault();
            $('.js-results').hide();
            $('.js-contanct-form').hide();

            const $this = $(this);

            $this.find('.form-error').text('');
            $this.find('input').removeClass('is-invalid');
            $this.find('.btn[type="submit"]').attr('disabled', true);


            const data = $this.serializeArray();

            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'general_construction_calculation_form',
                    data
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });

                        $('html, body').animate({
                            scrollTop: parseInt($("#general-construction-calculation-form").offset().top - $('.navbar').height())
                        }, 500);
                    }

                    if (response.status === "error_modal") {
                        $('.js-error-message').html(response.message);
                        $('.js-error-modal').show();
                    }

                    if (response.status === 'success') {
                        $('.js-results-inner').html(response.result).promise().done(function (e) {
                            $('.js-results').show();
                            $('.js-contanct-form').show();

                            $('html, body').animate({
                                scrollTop: parseInt($(".js-results").offset().top - $('.navbar').height())
                            }, 500);
                        });
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);

                });
        });


        $('#general-construction-contact-form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);
            $this.find('.btn[type="submit"]').addClass('d-none');
            $this.find('.js-loader').removeClass('d-none');

            const data = $this.serializeArray();
            const calculation_data = $('#general-construction-calculation-form').serializeArray();


            $.ajax({
                type: 'post',
                dataType: 'json',
                url: localize.ajaxurl,
                data: {
                    action: 'general_construction_calculation_contact_form',
                    data,
                    calculation_data
                }
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('#general-construction-calculation-form').trigger('reset');


                        $('.js-results-inner').html('').promise().done(function (e) {
                            $('.js-results').hide();


                            $('html, body').animate({
                                scrollTop: parseInt($(".section__calculator").offset().top - $('.navbar').height())
                            }, 500);
                        });

                        $('.js-contact-success-modal').show();


                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                    $this.find('.btn[type="submit"]').removeClass('d-none');
                    $this.find('.js-loader').addClass('d-none');
                });
        });

    });
})(jQuery);
